export default __webpack_public_path__ + "static/media/signIn_signUp_bg_maghreb.b0f5c3e5.png";